import {getSubmit} from "@ui-seeker/utils";
import {BACKEND_APIS} from "../../../@constants";
import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {searchID} from "@signals";

export default function useSearchDate() {
    const date = useSignal(null)
    const office = useSignal({})
    const isLoading = useSignal(false)

    const getData = useCallback(() => {
        isLoading.value = true
        getSubmit(`${BACKEND_APIS.MASTER_DATA}/execution/options/extra-data-idsearch`, {searchID: searchID.value})
            .then(({executionDateTime, officeData}) => batch(() => {
                isLoading.value = false
                date.value = executionDateTime;
                office.value = officeData;
            }))
    }, [])

    useEffect(() => {
        if(searchID.value) getData()
    }, [searchID.value]);


    return {
        office: office.value,
        date: date.value,
        isLoading:  isLoading.value
    }
}